import { Colors, Language, Lightning, Registry, Router, VideoPlayer } from '@lightningjs/sdk'
import Button from '../components/buttons/Button'
import PlayButton from '../components/buttons/PlayButton'
import AlbumCover from '../components/coverItems/AlbumCover'
import LargeText from '../components/LargeText'
import { cleanHtml, formatDate } from '../lib/AppHelpers'
import { appSettings } from '../lib/AppSettings'

export default class CatchupDetail extends Lightning.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      rect: true,
      color: Colors('PageBG').get(),
      // BlurWpr: {
      // 	type: Lightning.components.FastBlurComponent,
      // 	amount: 2,
      // 	w: 1920,
      // 	h: 1080,
      // },
      // BackGrd: {w: 1920, h: 1080},
      // Shade: {w: 1920, h: 1080, rect: true, alpha: 0.30, color: 0xff343434},
      AlbumCover: { w: 579, h: 579, x: 355, y: 251, type: AlbumCover },
      InfoWrapper: {
        w: 700,
        h: 580,
        x: 1013,
        y: 372,
        Start: {
          w: 800,
          h: 68,
          color: Colors('white').get(),
          text: { text: this.bindProp('start'), fontSize: 55, fontFace: 'OpenSansBold' },
        },
        Title: {
          w: 700,
          h: 30,
          color: Colors('white').get(),
          text: { text: this.bindProp('title'), fontSize: 25, fontFace: 'OpenSansRegular' },
        },
        DescrWrapper: {
          w: 700,
          h: 125,
          DescrSmall: {
            w: 700,
            color: Colors('white').get(),
            alpha: 1,
            text: {
              text: this.bindProp('descrSmall'),
              fontSize: 28,
              lineHeight: 40,
              wordWrapWidth: 700,
              fontFace: 'OpenSansRegular',
              maxLines: 3,
              textOverflow: 'ellipsis',
            },
          },
          DescrLarge: { x: -40, w: 700, h: 427, alpha: 0.001, type: LargeText, clipbox: false },
        },
        ButtonWrappr: {
          RewButton: {
            type: PlayButton,
            size: 80,
            buttonType: 'backward',
            icon: 'PlayerButtonBack',
          },
          PlayButton: {
            type: PlayButton,
            x: 90,
            size: 80,
            buttonType: 'playpause',
            icon: 'PlayerButtonPlay',
          },
          FwdButton: {
            type: PlayButton,
            x: 180,
            size: 80,
            buttonType: 'forward',
            icon: 'PlayerButtonForward',
          },
          Readmore: {
            w: 200,
            h: 60,
            x: 280,
            y: 10,
            type: Button,
            buttonText: Language.translate('Readmore'),
          },
        },
      },
    }
  }

  set items(data) {
    this._item = data
    this._item.background = data.background || appSettings.currentBrand.background
    // this.tag('BackGrd').texture = Img(this._item.background, { w: 1920, h: 1080, type: 'cover' });
    // this.tag('BlurWpr').content = {w: 1920, h: 1080, texture: Img(this._item.background, { w: 1920, h: 1080, type: 'cover' })};

    this.tag('AlbumCover').item = this._item.imageUrl
    this.tag('AlbumCover').itemBg = this._item.background ? this._item.background : ''
    // this.tag('AlbumCover').itemBg = appSettings.currentBrand.brandName ? itemBackgroundUrl(appSettings.currentBrand.brandName): '';

    const { title, startDate } = this._item
    const descr = cleanHtml(this._item.description)

    this.patch({
      start: formatDate(new Date(startDate), { weekday: 'long', day: 'numeric', month: 'long' }),
      title: title,
      descrSmall: descr,
    })
    this.tag('PlayButton').butnType =
      VideoPlayer.playing && VideoPlayer.src === this._item.streamUrl ? 'pause' : 'playpause'
    this.tag('DescrLarge').detailtext = descr
  }

  set autoPlay(v) {
    this._autoPlay = v
  }

  pageTransition() {
    return 'fade'
  }

  _init() {
    this._descrCollaps = true

    this.widgets['sidemenu'].activeMenuItem = 1
    this.tag('Start').on('txLoaded', () => {
      this.tag('Title').y = this.tag('Start').finalH + 8
    })
    this.tag('Title').on('txLoaded', () => {
      this.tag('DescrWrapper').y = this.tag('Title').y + this.tag('Title').finalH + 10
    })
    this.tag('DescrSmall').on('txLoaded', () => {
      this.tag('ButtonWrappr').y = this.tag('DescrWrapper').y + this.tag('DescrSmall').finalH + 20
      this.largeTextDims = this.tag('DescrLarge').dimensions
      this._showScroller = this.largeTextDims.height >= 427

      this.tag('Readmore').visible =
        this.tag('DescrSmall').finalH > 150 ||
        this.tag('DescrSmall').text.source.renderInfo.moreTextLines
    })

    this._expandAnimation = this.animation({
      duration: 0.4,
      repeat: 0,
      stopMethod: 'reverse',
      stopDuration: 0.2,
      actions: [
        { t: 'InfoWrapper', p: 'y', v: { 0: 372, 1: 240 } },
        { t: 'DescrWrapper', p: 'h', v: { 0: 150, 1: 445 } },
        { t: 'DescrLarge', p: 'alpha', v: { 0.5: 0, 1: 1 } },
        { t: 'DescrSmall', p: 'alpha', v: { 0.5: 1, 1: 0 } },
        {
          t: 'Readmore',
          p: 'buttonText',
          v: { 0: Language.translate('Readmore'), 1: Language.translate('Readless') },
        },
      ],
    })

    this._setState('Idle')
  }

  _active() {
    this._setState('PlayButton')
  }
  OnGpStateChange({ playbuttonState }) {
    this.tag('PlayButton').OnGpStateChange({ playbuttonState })
  }

  _inactive() {
    this.stage.gc()
  }
  playbackError() {
    this.widgets.errorbox.alpha = 1
    this.widgets.errorbox.notify({ type: 'playbackStopped', Notification: true })
    Router.focusWidget('ErrorBox')
  }
  _seekTo(direction, duration = 0) {
    this._userIsSeeking = true
    this._seekTarget = Math.floor(VideoPlayer.currentTime)
    Registry.clearTimeout(this._seekTimeout)
    VideoPlayer.pause()

    if (duration) {
      this._seekTarget = duration
    } else {
      if (direction === 'left') {
        this._seekTarget -= 10
      } else {
        this._seekTarget += 30
      }
      const duration = Math.floor(VideoPlayer.duration)
      if (this._seekTarget <= 0) {
        this._seekTarget = 1
      } else if (this._seekTarget > duration - 1) {
        this._seekTarget = duration - 1
      }
    }

    this._seekTimeout = Registry.setTimeout(() => {
      VideoPlayer.seek(this._seekTarget)
      Registry.clearTimeout(this._seekTimeout)
    }, 300)
  }

  _startReadMore(show) {
    let scrollerAlpha = show === true ? 1 : 0
    if (this._showScroller === false) {
      scrollerAlpha = 0
    }
    if (show === true) {
      this.tag('ButtonWrappr').y = this.tag('DescrWrapper').y + this.tag('DescrLarge').finalH + 20
      this._expandAnimation.start()
    } else {
      this.tag('ButtonWrappr').y = this.tag('DescrWrapper').y + this.tag('DescrSmall').finalH + 20
      this._expandAnimation.stop()
    }
    this.tag('DescrLarge').setScrollerAlpha = scrollerAlpha

    this._descrCollaps = show !== true
  }
  _handleForward() {
    this._seekTo('right')
    this._setState('ForwardButton')
  }
  _handleRewind() {
    this._seekTo('left')
    this._setState('RewindButton')
  }
  _handlePlay() {
    let isSameStream = VideoPlayer.src === this._item.streamUrl
    if (!VideoPlayer.playing || VideoPlayer.src !== this._item.streamUrl) {
      this._setState('PlayButton')
      if (this.widgets['globalplayer'].playbuttonState === 'pause' && isSameStream) {
        this.widgets.globalplayer.onPlayerUpdate({
          state: 'play',
          list: [{ url: this._item.streamUrl }],
          startIndex: 0,
          type: 'catchup',
          listType: 'episode',
          item: this._item,
        })
      } else {
        this.widgets.globalplayer.onPlayerUpdate({
          state: 'startplay',
          list: [{ url: this._item.streamUrl }],
          startIndex: 0,
          type: 'catchup',
          listType: 'episode',
          item: this._item,
        })
      }
    }
  }

  _handlePause() {
    this.widgets.globalplayer.onPlayerUpdate({
      state: 'pause',
      list: [{ url: this._item.streamUrl }],
      startIndex: 0,
      type: 'catchup',
      listType: 'episode',
      item: this._item,
    })
    this._setState('PlayButton')
  }

  _handlePlayPause() {
    let isSameStream = VideoPlayer.src === this._item.streamUrl
    this._setState('PlayButton')
    if (VideoPlayer.playing && isSameStream) {
      this.widgets.globalplayer.onPlayerUpdate({
        state: 'pause',
        list: [{ url: this._item.streamUrl }],
        startIndex: 0,
        type: 'catchup',
        listType: 'episode',
        item: this._item,
      })
    } else {
      if (this.widgets['globalplayer'].playbuttonState === 'pause' && isSameStream) {
        this.widgets.globalplayer.onPlayerUpdate({
          state: 'play',
          list: [{ url: this._item.streamUrl }],
          startIndex: 0,
          type: 'catchup',
          listType: 'episode',
          item: this._item,
        })
      } else {
        this.widgets.globalplayer.onPlayerUpdate({
          state: 'startplay',
          list: [{ url: this._item.streamUrl }],
          startIndex: 0,
          type: 'catchup',
          listType: 'episode',
          item: this._item,
        })
      }
    }
  }

  _handleStop() {
    if (VideoPlayer.playing) {
      VideoPlayer.close()
    }
  }

  static _states() {
    return [
      class Idle extends this {},

      class PlayButton extends this {
        $enter() {
          if (this._autoPlay) {
            this._handlePlayPause()
            this._autoPlay = false
          }
        }

        _handleLeft() {
          this._setState('RewindButton')
        }

        _handleRight() {
          this._setState('ForwardButton')
        }

        _handleEnter() {
          this._handlePlayPause()
        }

        _getFocused() {
          return this.tag('PlayButton')
        }
      },

      class ForwardButton extends this {
        _handleLeft() {
          this._setState('PlayButton')
        }
        _handleRight() {
          if (this.tag('Readmore').visible === true) {
            this._setState('Readmore')
          }
        }

        _handleEnter() {
          this._seekTo('right')
        }

        _getFocused() {
          return this.tag('FwdButton')
        }
      },

      class RewindButton extends this {
        _handleLeft() {
          if (this._descrCollaps === false) {
            if (this._showScroller === true) {
              this._setState('DescrLarge')
            } else {
              Router.focusWidget('SideMenu')
            }
          } else {
            Router.focusWidget('SideMenu')
          }
        }

        _handleRight() {
          this._setState('PlayButton')
        }

        _handleEnter() {
          this._seekTo('left')
        }

        _getFocused() {
          return this.tag('RewButton')
        }
      },

      class Readmore extends this {
        _handleLeft() {
          this._setState('PlayButton')
        }

        _handleEnter() {
          if (this._descrCollaps === true) {
            this._startReadMore(true)

            if (this._showScroller === true) {
              this._setState('DescrLarge')
            }
          } else {
            this._startReadMore(false)
          }
        }

        _getFocused() {
          return this.tag('Readmore')
        }
      },

      class DescrLarge extends this {
        _handleLeft() {
          Router.focusWidget('SideMenu')
        }

        _handleRight() {
          this._setState('RewindButton')
        }

        _getFocused() {
          return this.tag('DescrLarge')
        }
      },
    ]
  }
}
